import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CHART_COLORS } from '../../../utils/chartColors';
import EmptyState from '../../../components/ui/EmptyState';

export default function FunnelView({ data }) {
  if (data.mode === 'category') {
    if (data.steps.length === 0) return <EmptyState title="No candidates found for this category." />;

    return (
      <div>
        <p className="mb-4 text-sm text-gray-600">
          {data.category} — <strong>{data.entered}</strong> entered
        </p>
        <ResponsiveContainer width="100%" height={Math.max(240, data.steps.length * 30)}>
          <BarChart data={data.steps} layout="vertical" margin={{ left: 24 }}>
            <CartesianGrid strokeDasharray="0" horizontal={false} stroke={CHART_COLORS.grid} />
            <XAxis type="number" allowDecimals={false} tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} />
            <YAxis type="category" dataKey="title" width={220} tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} />
            <Tooltip contentStyle={{ borderRadius: 8, borderColor: CHART_COLORS.grid, fontSize: 13 }} />
            <Bar dataKey="reached" fill={CHART_COLORS.primary} radius={[0, 4, 4, 0]} maxBarSize={18} />
          </BarChart>
        </ResponsiveContainer>

        <table className="mt-4 min-w-full divide-y divide-gray-100 text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wide text-gray-400">
              <th className="py-2">Step</th>
              <th className="py-2">Reached</th>
              <th className="py-2">Conversion</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.steps.map((s) => (
              <tr key={s.title}>
                <td className="py-2 text-gray-700">{s.title}</td>
                <td className="py-2 text-gray-700">{s.reached}</td>
                <td className="py-2 text-gray-700">{s.conversion_percent}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={data.categories}>
          <CartesianGrid strokeDasharray="0" vertical={false} stroke={CHART_COLORS.grid} />
          <XAxis dataKey="category" tick={{ fill: CHART_COLORS.axis, fontSize: 11 }} axisLine={{ stroke: CHART_COLORS.grid }} tickLine={false} />
          <YAxis allowDecimals={false} tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} />
          <Tooltip contentStyle={{ borderRadius: 8, borderColor: CHART_COLORS.grid, fontSize: 13 }} />
          <Bar dataKey="hired" fill={CHART_COLORS.primary} radius={[4, 4, 0, 0]} maxBarSize={24} />
        </BarChart>
      </ResponsiveContainer>

      <table className="mt-4 min-w-full divide-y divide-gray-100 text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-gray-400">
            <th className="py-2">Category</th>
            <th className="py-2">Entered</th>
            <th className="py-2">Hired</th>
            <th className="py-2">Conversion</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {data.categories.map((c) => (
            <tr key={c.category}>
              <td className="py-2 text-gray-700">{c.category}</td>
              <td className="py-2 text-gray-700">{c.entered}</td>
              <td className="py-2 text-gray-700">{c.hired}</td>
              <td className="py-2 text-gray-700">{c.conversion_percent}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
